module.exports = __webpack_public_path__ + "img/barrido.69456828.png";